module.exports = __webpack_public_path__ + "static/Gallery-12-365b378214703db2bab9d24a073f6ed9.jpg";